import React, { useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';

import './iframe.scss';

interface IframeProps {
    src: string;
    height?: number | 'auto';
    width?: number | 'auto' | '100%';
}

const Iframe: React.FC<IframeProps> = ({ src, height = 300, width = '100%' }) => {
    const [currentHeight, setCurrentHeight] = useState(height);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const onView = (inView: boolean): void => {
        if (inView) {
            setCurrentHeight(iframeRef?.current?.contentWindow?.document?.body?.clientHeight || height);
        }
    };

    return (
        <div className="iframe">
            <InView triggerOnce={true} as="div" onChange={onView}>
                <iframe
                    style={{ width }}
                    ref={iframeRef}
                    src={src.replace('https://ocdn.eu', 'https://www.skapiec.pl')}
                    title="multimediaContent"
                    height={currentHeight}
                    onLoad={() => {
                        const body = iframeRef?.current?.contentWindow?.document?.body;

                        if (body) {
                            body.style.overflow = 'hidden';
                        }

                        body?.querySelectorAll('img[loading="lazy"]').forEach(node => {
                            node.removeAttribute('loading');
                        });

                        body?.querySelectorAll('img').forEach(node => {
                            node.style.pointerEvents = 'none';
                        });

                        setTimeout(() => {
                            setCurrentHeight(body?.clientHeight || height);
                        }, 50);

                        setCurrentHeight(body?.clientHeight || height);
                    }}
                />
            </InView>
        </div>
    );
};

export default Iframe;
